export const marketplaceRoutes = {
  default:'marketplace-frame'
}
